import { createFileRoute } from '@tanstack/react-router';
import {
  emailValidationLoader,
  redirectIfVerified,
} from 'router/loaders/emailValidation';
import { createOpportunityOnVerified } from 'router/loaders/onVerified/opportunity';
import { headSignupSubRoute } from 'router/utils';

import { PageSkeleton } from 'components/templates/PageSkeleton';
import { getOppSummaryQueryOptions } from 'services/partnersSelfSignup/opportunity';

export const Route = createFileRoute('/opportunity/$oppId/email-validation/')({
  pendingComponent: PageSkeleton,
  head: headSignupSubRoute,
  beforeLoad: async ({ context, params, cause }) => {
    const { queryClient } = context;
    const { oppId } = params;

    const summary = await queryClient.query(
      getOppSummaryQueryOptions({ oppId }),
    );

    // Where the Partner goes once the email is verified is the Terms &
    // Conditions flow's logic, so it supplies it to the OTP redirect and page.
    // https://tanstack.com/router/latest/docs/guide/router-context
    const email = summary.oppEmail;
    const onVerified = createOpportunityOnVerified({ context, oppId });

    await redirectIfVerified({
      queryClient,
      email,
      onVerified,
      cause,
      route: Route,
    });

    return { email, onVerified };
  },
  loader: args => emailValidationLoader(args),
});
